if (!customElements.get('sl-favorite')) {

  class Favorite extends HTMLElement {
    constructor() {
      super();

      this.favorites = window.gopuffShopify.customer ? window.gopuffShopify.customer.favorites.split(`, `).join(`,`).split(`,`).map((str) => Number(str)) : [];
      this.isLoading = false;
      this.gopuffProductID = Number(this.getAttribute(`gopuff-product-id`).split(`_`)[0]);
      this.addEventListener(`click`, this.handleClick);
      this.addEventListener(`keydown`, this.handleKeydown);
    }

    handleKeydown(event) {
      if ((event.key !== `Enter`) && (event.key !== ` `)) { return; }

      this.handleClick();
    }

    handleClick() {
      if (this.isLoading) { return; }

      const status = this.getAttribute(`status`);

      if (status !== `ready`) {
        const login = this.getAttribute(`login`) || `/account/login`;
        location.href = login;

        return;
      }

      const isSelected = this.getIsSelected();

      if (isSelected) {
        this.deselectFavorite();
      } else {
        this.selectFavorite();
      }
    }

    selectFavorite() {
      if (!this.gopuffProductID) { return; }

      this.isLoading = true;
      this.renderFavorite();

      this.updateFavorites([...this.favorites, this.gopuffProductID]);
    }

    deselectFavorite() {
      if (!this.gopuffProductID) { return; }

      this.isLoading = true;
      this.renderFavorite();

      const remaining_favorites = this.favorites.filter((id) => {
        return id !== this.gopuffProductID;
      });

      this.updateFavorites(remaining_favorites);
    }

    async updateFavorites(requested_favorites = []) {
      if (!window.gopuffShopify.customer) {
        console.error(`failed to update favorites - missing customer object`);
        this.isLoading = false;
        this.renderFavorite();

        return;
      }

      const favorites = requested_favorites.filter(filterUnique);
      const data = {
        customer_id: window?.gopuffShopify?.customer?.id,
        token: window?.gopuffShopify?.customer?.token,
        metafield: {
          key: `favorites`,
          type: `single_line_text_field`,
          value: favorites.join(`,`),
        }
      };

      await fetch(`${window.gopuffShopify.settings.api_base_url}/account/set-metafield?shop=${window.Shopify.shop}`, { ...fetchConfig(), ...{ body: JSON.stringify(data) } })
        .then((response) => response.json())
        .then((responseJSON) => {
          window.gopuffShopify.customer.favorites = responseJSON.favorites || favorites.join(`,`);
          this.isLoading = false;

          document.querySelectorAll(`sl-favorite`).forEach((favorite_el) => {
            favorite_el.setFavorites([...favorites]);
          })
          .catch(() => {
            gopuffCustomAnalytics.publishEndpointError(`/account/set-metafield`);
          });
        });
    }

    renderFavorite() {
      if (!this.gopuffProductID) {
        this.parentElement.classList.add(`hidden`);

        return;
      }

      const status = this.getAttribute(`status`);
      const isSelected = this.getIsSelected();
      this.classList.add(`favorite`);
      this.classList.toggle(`favorite--loading`, this.isLoading);
      this.classList.toggle(`favorite--selected`, isSelected);
      this.setAttribute(`tabindex`, 0);

      if (status === `ready`) {
        this.setAttribute(`role`, `button`);
        this.setAttribute(`aria-selected`, isSelected);
        this.setAttribute(`aria-label`, this.isLoading ? `Loading...` : `Favorite this product`);
      } else {
        this.setAttribute(`role`, `link`);
        this.setAttribute(`aria-label`, `Log in to favorite this product`);
      }
    }

    getIsSelected() {
      return Boolean(this.favorites.indexOf(this.gopuffProductID) > -1);
    }

    setFavorites(favorites = []) {
      this.favorites = [...favorites];
      this.renderFavorite();
    }

    connectedCallback() {
      this.renderFavorite();
    }
  }

  customElements.define(`sl-favorite`, Favorite);
}